export default {
    GET_ADMIN_PAYOUTS: {
        url: "/api/v1/payout/admin",
        method: "get",
    },
    SEND_ADMIN_LEADS_FOR_PAYMENT: {
        url: "/api/v1/payout/admin",
        method: "put",
    },
    ADMIN_CHANGE_PAYMENT_STATUS_TO_PROCESSED: {
        url: "/api/v1/payout/processed",
        method: "put",
    },
    ADD_CONNECTOR_PAYOUT: {
        url: "/api/v1/payout",
        method: "post",
    },
    GET_CONNECTOR_LEAD_COUNTS: {
        url: "/api/v1/connector-dashboard/lead-counts",
        method: "get",
    },
    GET_CONNECTOR_PAYOUTS: {
        url: "/api/v1/payout/connector",
        method: "get",
    },
    SEND_CONNECTOR_LEADS_FOR_PAYMENT: {
        url: "/api/v1/payout/connector",
        method: "put",
    },
    DOWNLOAD_CONNECTOR_PAYOUT: {
        url: "/api/v1/payout/admin/download",
        method: "get",
    },

    GET_UPLOADED_BANK_PAYOUTS: {
        url: "/api/v1/bank-payout/upload",
        method: "get",
    },

    MANUAL_TRIGGER_TO_MATCH_RECORDS: {
        url: "/api/v1/bank-payout/trigger",
        method: "post",
    },

    GET_PREVIOUSLY_RUNNED_BANK_PAYOUT_JOBS: {
        url: "/api/v1/bank-payout/jobs",
        method: "get",
    },

    // BULK FILES
    BULK_UPLOAD_BANK_PAYOUT: {
        url: "/api/v1/bank-payout/upload",
        method: "post",
    },
    DOWNLOAD_BANK_PAYOUT_TEMPLATE: {
        url: "/api/v1/bank-payout/template",
        method: "get",
    },

    // PAYMENT DETAILS
    GET_PAYMENT_INFO: {
        url: "/api/v1/payment-info/connector",
        method: "get",
    },
    GET_PAYMENT_INFO_BY_ID: {
        url: "/api/v1/payment-info/lead/{digiRepPaidAppId}",
        method: "get",
    },
    GET_PAYOUT_DASHBOARD: {
        url: "/api/v1/application/payout/payout-summary",
        method: "get",
    },
    DOWNLOAD_LEADS_PAYMENT: {
        url: "/api/v1/payment-info/admin/download",
        method: "get",
    },
}